import { Component, OnInit, Input, OnChanges, SimpleChanges} from '@angular/core';
import{LoopBackAuth, listadosService} from '../../shared/services/api-rest.service';
import{MessageService} from '../../shared/services/message.service';
import {FormGroup,FormBuilder,Validators,FormArray} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'datos-emergencia',
  template: `
  <form name="form-inscripciones" [formGroup]="emergencias">
    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
              <th width="180px">Tipo</th>
              <th>Teléfono</th>
              <th>Contacto</th>
              <th>
                  <button 
                    type="button" 
                    class="btn btn-primary p-1 m-0 f-11 d-flex align-items-center" 
                    [hidden]="preview"
                    (click)="addFila()"> 
                      <i class="fas fa-plus"></i> <span> Nuevo </span>
                  </button>
              </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of emergencias.controls | search:1  ; let i = index;" [formGroupName]="i" >
            <td> 
              <div
              class="input-group input-group-sm mb-0"
              [ngClass]="{'showError': !item.get('tipo').valid && item.get('tipo').touched}">
                  <select
                  class="form-control"
                  [style.border-radius]="'0px'"
                  formControlName="tipo"
                  >
                  <option *ngFor="let item of tipos" [value]="item.id">{{item.descripcion | uppercase}}</option>
                </select>
              </div>
            </td>
            <td> 
              <div
              class="input-group input-group-sm mb-0"
              [ngClass]="{'showError': !item.get('numero').valid && item.get('numero').touched}">
                <input
                    type="text"
                    class="form-control"
                    [style.border-radius]="'0px'"
                    maxlength="13"
                    formControlName="numero"
                >
              </div>
            </td>
            <td> 
              <div
                class="input-group input-group-sm mb-0"
                [ngClass]="{'showError': !item.get('contacto').valid && item.get('contacto').touched}">
                <input
                    type="text"
                    class="form-control"
                    formControlName="contacto"
                    [style.border-radius]="'0px'"
                    placeholder="Nombre,Parentesco"
                    frmUppercase
                >
              </div>
            </td>
            <td> 
              <i class="fas fa-trash-alt f-18 text-danger card-puntero" (click)="deleteFila(item, i)" [hidden]="preview"></i>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </form>
  `,
  providers:[LoopBackAuth, listadosService, MessageService]
})
export class DatosEmergenciaComponent implements OnInit, OnChanges {
  @Input() emergencias : FormArray
  @Input() preview : boolean = false
  public tipos: any[]
  constructor(
    public listadosService:listadosService,
    private fb: FormBuilder,
    private toastr: ToastrService,
  ) { }

  ngOnInit() {
    this.listadosService.grupos
     /** Busco el listado de tipos telefonicos */
     this.listadosService.grupos('G_TIPO_TELEFONO').subscribe(
      result =>{
        this.tipos = result.G_TIPO_TELEFONO.orden
        if(this.preview) this.onPreview()
      }
    )
    
    
  }
  ngOnChanges(changes:SimpleChanges) {
    
    if(changes.emergencias != undefined && changes.emergencias.currentValue != undefined){
      if(this.emergencias.controls.length == 0 ){
        this.addFila()
      } 
    }
  }
  onPreview(){
    for(let i=0; i < this.emergencias.controls.length ; i++){
      this.emergencias.controls[i].disable()
    }
  }

  public addFila(){
    console.log("Entre datos add fila-->")
    let item = this.emergencias as FormArray
    item.push(this.fb.group({
      id:[null],
      etiqueta:[36],
      operadora:[31],
      tipo:[null, Validators.required],
      numero:[null, Validators.required],
      extencion:[null],
      contacto:[null, Validators.required],
      predeterminado:[false],
      estado:[1],
      existe:[0],
    }))

    console.log("Entre datos add fila adciono-->", item.controls.length)
  }

  deleteFila(item:any, index:number):void{
    console.log("Item delete -->", item, index)
    if(item.get('existe').value == 1 && !item.get('predeterminado').value){
      item.patchValue({
        estado:-99
      })
    }else if(!item.get('predeterminado').value){
      this.emergencias.removeAt(index)
    }else{
      this.toastr.warning("No puede borrar, tiene como favorito", "Eliminar Teléfono")
    }

  }

}



// WEBPACK FOOTER //
// ./src/app/shared/fichaEstudiante/datos-emergencia.component.ts